import { z } from 'zod';
export const GooglePlaceSchema = z.object({
    placeId: z.string().optional(),
    lat: z.number().optional(),
    lng: z.number().optional(),
    data: z.any().optional(),
    polygon: z.array(z.array(z.number())).optional(),
    polygonWKT: z.string().optional(),
    name: z.string().optional(),
    formatedAddress: z.string().optional()
});
//# sourceMappingURL=googlePlaceSchema.js.map